import React, { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { Section } from "./Common";
import { useDataSync } from "../lib/realtime";
import { Megaphone } from "lucide-react";

export const NoticeBoard = () => {
  const [notices, setNotices] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications");
      setNotices(data);
      if (data.length) {
        api.post("/notifications/mark-read", { ids: data.map((n) => n.id) }).catch(() => {});
      }
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load]);
  useDataSync(["notifications"], () => load());

  const visible = showAll ? notices : notices.slice(0, 4);

  return (
    <Section
      title={
        <span className="inline-flex items-center gap-2">
          <Megaphone className="h-4 w-4 text-blue-600" /> Notice board
        </span>
      }
      actions={notices.length > 4 && (
        <button
          data-testid="notices-toggle-all"
          onClick={() => setShowAll((v) => !v)}
          className="text-xs font-semibold text-blue-600 hover:underline"
        >
          {showAll ? "Show less" : `View all (${notices.length})`}
        </button>
      )}
    >
      <div className="space-y-3" data-testid="notice-board">
        {visible.map((n) => (
          <div key={n.id} data-testid={`notice-${n.id}`} className="p-4 rounded-xl bg-blue-50/60 border border-blue-100">
            <div className="flex items-start justify-between gap-3">
              <h4 className="font-heading font-bold text-slate-900">{n.title}</h4>
              <span className="text-[11px] text-slate-500 whitespace-nowrap shrink-0">
                {new Date(n.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
              </span>
            </div>
            <p className="mt-1 text-sm text-slate-600 whitespace-pre-wrap">{n.body}</p>
            {n.from_user_name && (
              <p className="mt-2 text-[11px] font-semibold uppercase tracking-wider text-blue-600">— {n.from_user_name}</p>
            )}
          </div>
        ))}
        {notices.length === 0 && (
          <p className="text-sm text-slate-500" data-testid="notices-empty">No announcements yet.</p>
        )}
      </div>
    </Section>
  );
};
